import { render, staticRenderFns } from "./footerIndex.vue?vue&type=template&id=2fb989d4&scoped=true&"
import script from "./footerIndex.vue?vue&type=script&lang=js&"
export * from "./footerIndex.vue?vue&type=script&lang=js&"
import style0 from "./footerIndex.vue?vue&type=style&index=0&id=2fb989d4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb989d4",
  null
  
)

export default component.exports